export const applicationFormConfig = {
  steps: [
    {
      id: 'student',
      label: 'Student Information',
      icon: 'Person',
      description: 'Basic student details',
      fields: [
        {
          name: 'studentFirstName',
          label: 'First Name',
          type: 'text',
          required: true,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 1, column: 1 },
          visible: true,
          group: 'studentInfo',
          validation: {
            required: 'First name is required'
          }
        },
        {
          name: 'studentMiddleName',
          label: 'Middle Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 1, column: 2 },
          visible: true,
          group: 'studentInfo',
        },
        {
          name: 'studentLastName',
          label: 'Last Name',
          type: 'text',
          required: true,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 1, column: 3 },
          visible: true,
          group: 'studentInfo',
          validation: {
            required: 'Last name is required'
          }
        },
        {
          name: 'address',
          label: 'Address',
          type: 'text',
          required: true,
          gridSize: { xs: 12, sm: 12 },
          layout: { row: 2, column: 1, span: 3 },
          visible: true,
          group: 'studentAddress',
          validation: {
            required: 'Address is required'
          }
        },
        {
          name: 'city',
          label: 'City',
          type: 'text',
          required: true,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 3, column: 1 },
          visible: true,
          group: 'studentAddress',
          validation: {
            required: 'City is required'
          }
        },
        {
          name: 'state',
          label: 'State',
          type: 'select',
          required: true,
          gridSize: { xs: 12, sm: 4, maxWidth: '200px' },
          layout: { row: 3, column: 2 },
          visible: true,
          group: 'studentAddress',
          options: [
            { value: 'AL', label: 'Alabama' },
            { value: 'AK', label: 'Alaska' },
            { value: 'AZ', label: 'Arizona' },
            { value: 'AR', label: 'Arkansas' },
            { value: 'CA', label: 'California' },
            { value: 'CO', label: 'Colorado' },
            { value: 'CT', label: 'Connecticut' },
            { value: 'DE', label: 'Delaware' },
            { value: 'FL', label: 'Florida' },
            { value: 'GA', label: 'Georgia' },
            { value: 'HI', label: 'Hawaii' },
            { value: 'ID', label: 'Idaho' },
            { value: 'IL', label: 'Illinois' },
            { value: 'IN', label: 'Indiana' },
            { value: 'IA', label: 'Iowa' },
            { value: 'KS', label: 'Kansas' },
            { value: 'KY', label: 'Kentucky' },
            { value: 'LA', label: 'Louisiana' },
            { value: 'ME', label: 'Maine' },
            { value: 'MD', label: 'Maryland' },
            { value: 'MA', label: 'Massachusetts' },
            { value: 'MI', label: 'Michigan' },
            { value: 'MN', label: 'Minnesota' },
            { value: 'MS', label: 'Mississippi' },
            { value: 'MO', label: 'Missouri' },
            { value: 'MT', label: 'Montana' },
            { value: 'NE', label: 'Nebraska' },
            { value: 'NV', label: 'Nevada' },
            { value: 'NH', label: 'New Hampshire' },
            { value: 'NJ', label: 'New Jersey' },
            { value: 'NM', label: 'New Mexico' },
            { value: 'NY', label: 'New York' },
            { value: 'NC', label: 'North Carolina' },
            { value: 'ND', label: 'North Dakota' },
            { value: 'OH', label: 'Ohio' },
            { value: 'OK', label: 'Oklahoma' },
            { value: 'OR', label: 'Oregon' },
            { value: 'PA', label: 'Pennsylvania' },
            { value: 'RI', label: 'Rhode Island' },
            { value: 'SC', label: 'South Carolina' },
            { value: 'SD', label: 'South Dakota' },
            { value: 'TN', label: 'Tennessee' },
            { value: 'TX', label: 'Texas' },
            { value: 'UT', label: 'Utah' },
            { value: 'VT', label: 'Vermont' },
            { value: 'VA', label: 'Virginia' },
            { value: 'WA', label: 'Washington' },
            { value: 'WV', label: 'West Virginia' },
            { value: 'WI', label: 'Wisconsin' },
            { value: 'WY', label: 'Wyoming' }
          ],
          validation: {
            required: 'State is required'
          }
        },
        {
          name: 'zip',
          label: 'ZIP',
          type: 'text',
          required: true,
          gridSize: { xs: 12, sm: 4, maxWidth: '140px' },
          layout: { row: 3, column: 3 },
          visible: true,
          group: 'studentAddress',
          validation: {
            required: 'ZIP code is required'
          }
        },
        {
          name: 'birthplace',
          label: 'Birthplace',
          type: 'text',
          required: false,
          visible: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 4, column: 1 },
        },
        {
          name: 'phone',
          label: 'Telephone',
          type: 'tel',
          required: true,
          gridSize: { xs: 12 },
          layout: { row: 4, column: 2 },
          visible: true,
          icon: 'Phone',
          group: 'studentContact',
          placeholder: '(555) 867-5309',
          validation: {
            required: 'Phone number is required'
          }
        },
        {
          name: 'age',
          label: 'Age',
          type: 'number',
          required: false,
          visible: true,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 5, column: 1 },
        },
        {
          name: 'gender',
          label: 'Sex',
          type: 'select',
          required: false,
          visible: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 5, column: 2 },
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        },
        {
          name: 'dateOfBirth',
          label: 'Birth Date',
          type: 'date',
          required: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 5, column: 3 },
          visible: true,
          icon: 'CalendarToday',
          group: 'studentAcademic',
          validation: {
            required: 'Date of birth is required'
          }
        },
        {
          name: 'previousSchool',
          label: 'School Last Attended',
          type: 'text',
          required: false,
          visible: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 6, column: 1 },
        },
        {
          name: 'previousSchoolAddress',
          label: 'School Address',
          type: 'text',
          visible: true,
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 6, column: 2 },
        },
        {
          name: 'grade',
          label: 'Grade Applying For',
          type: 'select',
          required: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 5, column: 1 },
          visible: true,
          group: 'studentAcademic',
          options: [
            { value: 'K', label: 'Kindergarten' },
            { value: '1', label: '1st Grade' },
            { value: '2', label: '2nd Grade' },
            { value: '3', label: '3rd Grade' },
            { value: '4', label: '4th Grade' },
            { value: '5', label: '5th Grade' },
            { value: '6', label: '6th Grade' },
            { value: '7', label: '7th Grade' },
            { value: '8', label: '8th Grade' },
            { value: '9', label: '9th Grade' },
            { value: '10', label: '10th Grade' },
            { value: '11', label: '11th Grade' },
            { value: '12', label: '12th Grade' }
          ],
          validation: {
            required: 'Grade is required'
          }
        },
        {
          name: 'termYear',
          label: 'Term Year',
          type: 'select',
          visible: true,
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 7, column: 2 },
          options: (() => {
            const y = new Date().getFullYear();
            return [y, y + 1, y + 2].map(yr => ({ value: `${yr}-${yr + 1}`, label: `${yr}-${yr + 1}` }));
          })()
        }
      ]
    },
    {
      id: 'medical',
      label: 'Medical Information',
      icon: 'HealthAndSafety',
      description: 'Health and medical details',
      fields: [
        {
          name: 'familyPhysician',
          label: 'Family Physician',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 1, column: 1 },
        },
        {
          name: 'physicianPhone',
          label: 'Physician Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 1, column: 2 },
          placeholder: '(555) 123-4567'
        },
        {
          name: 'immunizationDTP',
          label: 'DTP/DTaP/DT/Td Immunization',
          type: 'checkbox',
          required: false,
          gridSize: { xs: 12, sm: 4, maxWidth: '280px' },
          layout: { row: 2, column: 1 },
          group: 'immunizations',
        },
        {
          name: 'immunizationPolio',
          label: 'Polio Immunization',
          type: 'checkbox',
          required: false,
          gridSize: { xs: 12, sm: 4, maxWidth: '280px' },
          layout: { row: 2, column: 2 },
          group: 'immunizations',
        },
        {
          name: 'immunizationMMR',
          label: 'MMR Immunization',
          type: 'checkbox',
          required: false,
          gridSize: { xs: 12, sm: 4, maxWidth: '280px' },
          layout: { row: 2, column: 3 },
          group: 'immunizations',
        },
        {
          name: 'immunizationVaricella',
          label: 'Varicella Immunization',
          type: 'checkbox',
          required: false,
          gridSize: { xs: 12, sm: 4, maxWidth: '280px' },
          layout: { row: 3, column: 1 },
          group: 'immunizations',
        },
        {
          name: 'immunizationHepatitisB',
          label: 'Hepatitis B Immunization',
          type: 'checkbox',
          required: false,
          gridSize: { xs: 12, sm: 4, maxWidth: '280px' },
          layout: { row: 3, column: 2 },
          group: 'immunizations',
        },
        {
          name: 'physicalDefectsAllergies',
          label: 'Does student have any physical defects or allergies?',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 4, column: 1, span: 3 },
          placeholder: 'Please explain any physical defects or allergies',
          rows: 4,
          sx: { 
            width: '100%',
            display: 'block',
            '& .MuiInputBase-root': { width: '100%' }
          }
        }
      ]
    },
    {
      id: 'scholastic',
      label: 'Scholastic Information',
      icon: 'School',
      description: 'Academic history and behavior',
      fields: [
        {
          name: 'lastGradeCompleted',
          label: 'Last Grade Completed',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 4 },
          layout: { row: 1, column: 1 },
          options: [
            { value: 'K', label: 'Kindergarten' },
            { value: '1', label: '1st Grade' },
            { value: '2', label: '2nd Grade' },
            { value: '3', label: '3rd Grade' },
            { value: '4', label: '4th Grade' },
            { value: '5', label: '5th Grade' },
            { value: '6', label: '6th Grade' },
            { value: '7', label: '7th Grade' },
            { value: '8', label: '8th Grade' },
            { value: '9', label: '9th Grade' },
            { value: '10', label: '10th Grade' },
            { value: '11', label: '11th Grade' },
            { value: '12', label: '12th Grade' }
          ]
        },
        {
          name: 'academicLevel',
          label: 'Academic Level of Previous Work',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 8 },
          layout: { row: 1, column: 2 },
          options: [
            { value: 'excellent', label: 'Excellent' },
            { value: 'good', label: 'Good' },
            { value: 'average', label: 'Average' },
            { value: 'poor', label: 'Poor' }
          ]
        },
        {
          name: 'expelledDismissed',
          label: 'Has student ever been expelled, dismissed, suspended, or refused admission to another school?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 2, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'expelledDismissedExplanation',
          label: 'If yes, please explain:',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 3, column: 1, span: 2 },
          rows: 2,
          conditional: {
            field: 'expelledDismissed',
            value: 'true'
          }
        },
        {
          name: 'disciplinaryDifficulty',
          label: 'Has student ever had disciplinary difficulty at school?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 4, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'disciplinaryDifficultyExplanation',
          label: 'If yes, please explain:',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 5, column: 1, span: 2 },
          rows: 2,
          conditional: {
            field: 'disciplinaryDifficulty',
            value: 'true'
          }
        },
        {
          name: 'juvenileRecord',
          label: 'Does student have a juvenile or arrest record?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 6, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'juvenileRecordExplanation',
          label: 'If yes, please explain:',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 7, column: 1, span: 2 },
          rows: 2,
          conditional: {
            field: 'juvenileRecord',
            value: 'true'
          }
        },
        {
          name: 'tobaccoDrugs',
          label: 'Has student ever used tobacco or nonprescription drugs of any kind?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 8, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'tobaccoDrugsExplanation',
          label: 'If yes, please explain:',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 9, column: 1, span: 2 },
          rows: 2,
          conditional: {
            field: 'tobaccoDrugs',
            value: 'true'
          }
        },
        {
          name: 'failedSubjects',
          label: 'Has student ever failed an academic subject in school?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 10, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'failedSubjectsExplanation',
          label: 'If yes, please explain:',
          type: 'textarea',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 11, column: 1, span: 2 },
          rows: 2,
          conditional: {
            field: 'failedSubjects',
            value: 'true'
          }
        }
      ]
    },
    {
      id: 'family',
      label: 'Family Information',
      icon: 'FamilyRestroom',
      description: 'Parent and family details',
      fields: [
        {
          name: 'addAnotherParent',
          label: 'Add Parent/Guardian',
          type: 'button',
          icon: 'Add',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 1, column: 1 },
          group: 'parentGuardianSelection'
        },

        // Parent/Guardian 1 Fields
        {
          name: 'parent1Relationship',
          label: 'Relationship to Student',
          type: 'select',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 2, column: 1 },
          options: [
            { value: 'father', label: 'Father' },
            { value: 'mother', label: 'Mother' },
            { value: 'guardian', label: 'Legal Guardian' },
            { value: 'other', label: 'Other' }
          ],
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 1 },
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 2 },
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1Email',
          label: 'Email',
          type: 'email',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 5, column: 1 },
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1Phone',
          label: 'Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 6, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },

        // Parent/Guardian 1 Employment Fields
        {
          name: 'parent1Employment',
          label: 'Employer',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 7, column: 1 },
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1Position',
          label: 'Job Title',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 8, column: 1 },
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },
        {
          name: 'parent1BusinessPhone',
          label: 'Business Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 9, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 1,
          group: 'parent1Info'
        },

        // Parent/Guardian 2 Fields
        {
          name: 'removeParent2',
          label: 'Remove Parent/Guardian',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 10, column: 1 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2Relationship',
          label: 'Relationship to Student',
          type: 'select',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 11, column: 1 },
          options: [
            { value: 'father', label: 'Father' },
            { value: 'mother', label: 'Mother' },
            { value: 'guardian', label: 'Legal Guardian' },
            { value: 'other', label: 'Other' }
          ],
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 12, column: 1 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 12, column: 2 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2Email',
          label: 'Email',
          type: 'email',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 14, column: 1 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2Phone',
          label: 'Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 15, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },

        // Parent/Guardian 2 Employment Fields
        {
          name: 'parent2Employment',
          label: 'Employer',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 16, column: 1 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2Position',
          label: 'Job Title',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 17, column: 1 },
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },
        {
          name: 'parent2BusinessPhone',
          label: 'Business Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 18, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 2,
          group: 'parent2Info'
        },

        // Parent/Guardian 3 Fields
        {
          name: 'removeParent3',
          label: 'Remove Parent/Guardian',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 22, column: 1 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3Relationship',
          label: 'Relationship to Student',
          type: 'select',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 23, column: 1 },
          options: [
            { value: 'father', label: 'Father' },
            { value: 'mother', label: 'Mother' },
            { value: 'guardian', label: 'Legal Guardian' },
            { value: 'other', label: 'Other' }
          ],
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 24, column: 1 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 24, column: 2 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3Email',
          label: 'Email',
          type: 'email',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 26, column: 1 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3Phone',
          label: 'Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 27, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },

        // Parent/Guardian 3 Employment Fields
        {
          name: 'parent3Employment',
          label: 'Employer',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 28, column: 1 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3Position',
          label: 'Job Title',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 29, column: 1 },
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },
        {
          name: 'parent3BusinessPhone',
          label: 'Business Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 30, column: 1 },
          placeholder: '(555) 123-4567',
          visible: (formData) => formData.parentCount >= 3,
          group: 'parent3Info'
        },

        // Parent as Emergency Contact Selection
        {
          name: 'useParentAsEmergencyContact',
          label: 'Use a Parent/Guardian as Emergency Contact?',
          type: 'select',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 31, column: 1 },
          options: [
            { value: 'none', label: 'No, use other emergency contact' },
            { value: 'parent1', label: 'Use Parent/Guardian 1' },
            { value: 'parent2', label: 'Use Parent/Guardian 2', disabled: (formData) => !formData.parentCount || formData.parentCount < 2 },
            { value: 'parent3', label: 'Use Parent/Guardian 3', disabled: (formData) => !formData.parentCount || formData.parentCount < 3 }
          ],
          visible: (formData) => formData.parentCount >= 1,
          group: 'emergencyContactSelection'
        },

        // Emergency Contact Fields - Simplified
        {
          name: 'emergencyContactBox',
          type: 'box',
          gridSize: { xs: 12 },
          layout: { row: 32, column: 1 },
          visible: (formData) => formData.useParentAsEmergencyContact !== undefined && formData.useParentAsEmergencyContact === 'none',
          sx: { 
            border: '1px solid #e0e0e0', 
            borderRadius: '4px', 
            padding: '16px', 
            marginTop: '16px',
            backgroundColor: '#f9f9f9'
          },
          label: 'Emergency Contact Information',
          group: 'emergencyContactBox',
          children: [
            {
              name: 'emergencyContactRelationship',
              label: 'Relationship',
              type: 'select',
              required: false,
              gridSize: { xs: 12 },
              layout: { row: 3, column: 2 },
              options: [
                { value: 'parent', label: 'Parent' },
                { value: 'grandparent', label: 'Grandparent' },
                { value: 'sibling', label: 'Sibling' },
                { value: 'aunt_uncle', label: 'Aunt/Uncle' },
                { value: 'friend', label: 'Friend' },
                { value: 'neighbor', label: 'Neighbor' },
                { value: 'other', label: 'Other' }
              ],
              group: 'emergencyContact'
            },
            {
              name: 'emergencyContactOtherRelationship',
              label: 'Please Specify Relationship',
              type: 'text',
              required: false,
              gridSize: { xs: 12 },
              layout: { row: 4, column: 1 },
              visible: (formData) => formData.emergencyContactRelationship === 'other',
              group: 'emergencyContact'
            },
            {
              name: 'emergencyContactFirstName',
              label: 'First Name',
              type: 'text',
              required: true,
              gridSize: { xs: 12, sm: 6 },
              layout: { row: 2, column: 1 },
              validation: {
                required: 'Emergency contact first name is required'
              },
              group: 'emergencyContact'
            },
            {
              name: 'emergencyContactLastName',
              label: 'Last Name',
              type: 'text',
              required: true,
              gridSize: { xs: 12, sm: 6 },
              layout: { row: 2, column: 2 },
              validation: {
                required: 'Emergency contact last name is required'
              },
              group: 'emergencyContact'
            },
            {
              name: 'emergencyContactPhone',
              label: 'Phone',
              type: 'tel',
              required: true,
              gridSize: { xs: 12 },
              layout: { row: 3, column: 1 },
              placeholder: '(555) 123-4567',
              validation: {
                required: 'Emergency contact phone is required'
              },
              group: 'emergencyContact'
            }
          ]
        },

        // Other Family Information
        {
          name: 'maritalStatus',
          label: 'Marital Status',
          type: 'select',
          required: false,
          visible: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 36, column: 1 },
          options: [
            { value: 'married', label: 'Married' },
            { value: 'divorced', label: 'Divorced' },
            { value: 'separated', label: 'Separated' },
            { value: 'widow', label: 'Widow' }
          ]
        },
        // Siblings Section
        {
          name: 'addSibling',
          label: 'Add Sibling',
          type: 'button',
          icon: 'Add',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 37, column: 1 },
          group: 'siblingSelection'
        },

        // Sibling 1
        {
          name: 'removeSibling1',
          label: 'Remove Sibling',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 38, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 1,
          group: 'sibling1Info'
        },
        {
          name: 'sibling1FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 39, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 1,
          group: 'sibling1Info'
        },
        {
          name: 'sibling1LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 39, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 1,
          group: 'sibling1Info'
        },
        {
          name: 'sibling1Age',
          label: 'Age',
          type: 'number',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 40, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 1,
          group: 'sibling1Info'
        },
        {
          name: 'sibling1Gender',
          label: 'Gender',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 40, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 1,
          group: 'sibling1Info',
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        },

        // Sibling 2
        {
          name: 'removeSibling2',
          label: 'Remove Sibling',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 41, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 2,
          group: 'sibling2Info'
        },
        {
          name: 'sibling2FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 42, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 2,
          group: 'sibling2Info'
        },
        {
          name: 'sibling2LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 42, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 2,
          group: 'sibling2Info'
        },
        {
          name: 'sibling2Age',
          label: 'Age',
          type: 'number',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 43, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 2,
          group: 'sibling2Info'
        },
        {
          name: 'sibling2Gender',
          label: 'Gender',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 43, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 2,
          group: 'sibling2Info',
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        },

        // Sibling 3
        {
          name: 'removeSibling3',
          label: 'Remove Sibling',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 44, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 3,
          group: 'sibling3Info'
        },
        {
          name: 'sibling3FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 45, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 3,
          group: 'sibling3Info'
        },
        {
          name: 'sibling3LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 45, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 3,
          group: 'sibling3Info'
        },
        {
          name: 'sibling3Age',
          label: 'Age',
          type: 'number',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 46, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 3,
          group: 'sibling3Info'
        },
        {
          name: 'sibling3Gender',
          label: 'Gender',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 46, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 3,
          group: 'sibling3Info',
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        },

        // Sibling 4
        {
          name: 'removeSibling4',
          label: 'Remove Sibling',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 47, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 4,
          group: 'sibling4Info'
        },
        {
          name: 'sibling4FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 48, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 4,
          group: 'sibling4Info'
        },
        {
          name: 'sibling4LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 48, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 4,
          group: 'sibling4Info'
        },
        {
          name: 'sibling4Age',
          label: 'Age',
          type: 'number',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 49, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 4,
          group: 'sibling4Info'
        },
        {
          name: 'sibling4Gender',
          label: 'Gender',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 49, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 4,
          group: 'sibling4Info',
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        },

        // Sibling 5
        {
          name: 'removeSibling5',
          label: 'Remove Sibling',
          type: 'button',
          icon: 'Remove',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 50, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 5,
          group: 'sibling5Info'
        },
        {
          name: 'sibling5FirstName',
          label: 'First Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 51, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 5,
          group: 'sibling5Info'
        },
        {
          name: 'sibling5LastName',
          label: 'Last Name',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 51, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 5,
          group: 'sibling5Info'
        },
        {
          name: 'sibling5Age',
          label: 'Age',
          type: 'number',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 52, column: 1 },
          visible: (formData) => (formData.siblingCount || 0) >= 5,
          group: 'sibling5Info'
        },
        {
          name: 'sibling5Gender',
          label: 'Gender',
          type: 'select',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 52, column: 2 },
          visible: (formData) => (formData.siblingCount || 0) >= 5,
          group: 'sibling5Info',
          options: [
            { value: 'male', label: 'Male' },
            { value: 'female', label: 'Female' }
          ]
        }
      ]
    },
    {
      id: 'religious',
      label: 'Religious Information',
      icon: 'Church',
      description: 'Church and faith details',
      fields: [
        {
          name: 'church',
          label: 'Church Attending',
          type: 'text',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 1, column: 1 },
        },
        {
          name: 'pastor',
          label: 'Pastor',
          type: 'text',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 2, column: 1 },
        },
        {
          name: 'churchPhone',
          label: 'Church Phone',
          type: 'tel',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 2, column: 2 },
          placeholder: '(555) 123-4567'
        },
        {
          name: 'churchAddress',
          label: 'Church Address',
          type: 'text',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 3, column: 1 },
        },
        {
          name: 'fatherChristian',
          label: 'Father: Christian?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 1 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'motherChristian',
          label: 'Mother: Christian?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        },
        {
          name: 'studentProfessionOfFaith',
          label: 'Has applicant ever made a profession of faith in Christ?',
          type: 'radio',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 4, column: 1, span: 2 },
          options: [
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' }
          ]
        }
      ]
    },
    {
      id: 'general',
      label: 'General Information',
      icon: 'Info',
      description: 'Additional information',
      fields: [
        {
          name: 'howHeardAbout',
          label: 'How did you hear about this school?',
          type: 'select',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 1, column: 1, span: 2 },
          options: [
            { value: 'friend', label: 'Friend or Family' },
            { value: 'church', label: 'Church' },
            { value: 'internet', label: 'Internet Search' },
            { value: 'social', label: 'Social Media' },
            { value: 'advertisement', label: 'Advertisement' },
            { value: 'other', label: 'Other' }
          ]
        },
        {
          name: 'reasonForApplying',
          label: 'Reason for selecting this school',
          type: 'textarea',
          required: true,
          gridSize: { xs: 12 },
          layout: { row: 2, column: 1, span: 2 },
          placeholder: 'Tell us why you selected Eagles Refuge Academy...',
          rows: 5,
          helperText: 'Please share what interests you about our school',
          validation: {
            required: 'Please tell us why you selected our school'
          }
        },
        {
          name: 'email',
          label: 'Email Address',
          type: 'email',
          required: true,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 1 },
          icon: 'Email',
          validation: {
            required: 'Email is required'
          }
        },
        {
          name: 'additionalEmail',
          label: 'Secondary Email Address',
          type: 'email',
          required: false,
          gridSize: { xs: 12, sm: 6 },
          layout: { row: 3, column: 2 },
          icon: 'Email',
          // Example 1: Function-based visibility - only show if primary email is from gmail.com
          visible: (formData) => formData.email && formData.email.endsWith('@gmail.com')
        },
        {
          name: 'otherSchoolInfo',
          label: 'Other School Information',
          type: 'text',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 4, column: 1, span: 2 },
          visible: true
        },
        {
          name: 'referralCode',
          label: 'Referral Code (if you heard from a friend)',
          type: 'text',
          required: false,
          gridSize: { xs: 12 },
          layout: { row: 5, column: 1, span: 2 },
          // Example 3: Function-based visibility with complex condition
          visible: (formData) => formData.howHeardAbout === 'friend'
        }
      ]
    }
  ]
};

/**
 * Field Visibility Control Options:
 * 
 * Fields can be conditionally shown or hidden using the following properties:
 * 
 * 1. visible: boolean - Set to false to always hide the field
 *    Example: visible: false
 * 
 * 2. visible: function - A function that takes the current formData and returns a boolean
 *    Example: visible: (formData) => formData.someField === 'someValue'
 * 
 * 3. conditional: object - (Legacy method) An object with field and value properties
 *    Example: conditional: { field: 'someField', value: 'someValue' }
 * 
 * The visible function approach is more flexible as it allows for complex conditions
 * based on multiple fields or partial matches.
 */

// Helper function to get initial form data from config
export const getInitialFormData = (config = applicationFormConfig) => {
  const initialData = {};
  config.steps.forEach(step => {
    step.fields.forEach(field => {
      initialData[field.name] = '';
    });
  });
  // Set default value for parentCount to show first parent by default
  initialData.parentCount = 1;
  initialData.siblingCount = 0;
  return initialData;
};

/**
 * Returns the active form config, merging any admin-saved overrides from
 * localStorage on top of the static default config.
 *
 * Function-based `visible` handlers (dynamic parent fields, etc.) are always
 * restored from the original static config so they survive JSON round-trips.
 */
/**
 * Returns the active form config, merging any admin-saved overrides from
 * localStorage on top of the static default config.
 *
 * The static config is always the source of truth for structure — every step
 * and field defined there will always be present. Saved state only applies
 * overrides (visibility, labels, etc.) to existing fields, and appends any
 * brand-new steps/fields added by the admin.
 *
 * Function-based `visible` handlers survive JSON round-trips because they are
 * always restored from the static config.
 */
export const getActiveFormConfig = () => {
  const saved = localStorage.getItem('applicationFormConfig');
  if (!saved) return applicationFormConfig;
  try {
    const savedConfig = JSON.parse(saved);

    // Walk every step in the STATIC config — these are always included
    const mergedSteps = applicationFormConfig.steps.map(origStep => {
      const savedStep = savedConfig.steps?.find(s => s.id === origStep.id);
      if (!savedStep) return origStep; // Step not in saved yet — use original as-is

      // Walk every field in the STATIC step — always included
      const mergedFields = origStep.fields.map(origField => {
        const savedField = savedStep.fields?.find(f => f.name === origField.name);
        if (!savedField) return origField; // Field not in saved — use original

        // Apply saved overrides onto original, but always keep structural properties
        // (type, options) from the static config so code changes always take effect.
        const merged = { ...origField, ...savedField, type: origField.type, options: origField.options };
        if (typeof origField.visible === 'function') {
          merged.visible = origField.visible; // Never lose dynamic visibility logic
        }
        return merged;
      });

      // Append any brand-new fields the admin added (not in static config)
      const adminAddedFields = (savedStep.fields || []).filter(
        sf => !origStep.fields.find(of => of.name === sf.name)
      );

      return { ...origStep, ...savedStep, fields: [...mergedFields, ...adminAddedFields] };
    });

    // Append any brand-new steps the admin added (not in static config)
    const adminAddedSteps = (savedConfig.steps || []).filter(
      ss => !applicationFormConfig.steps.find(os => os.id === ss.id)
    );

    return { ...applicationFormConfig, steps: [...mergedSteps, ...adminAddedSteps] };
  } catch (e) {
    return applicationFormConfig;
  }
};

// Helper function to get all required fields for validation
export const getRequiredFields = () => {
  const requiredFields = {};
  applicationFormConfig.steps.forEach(step => {
    step.fields.forEach(field => {
      if (field.required) {
        requiredFields[field.name] = field.validation;
      }
    });
  });
  return requiredFields;
};

// Helper function to organize fields by layout
export const getFieldsByLayout = (fields) => {
  const layout = {};

  fields.forEach(field => {
    if (!field.layout) {
      console.warn(`Field ${field.name} has no layout property`);
      return;
    }

    const { row, column, span = 1 } = field.layout;

    if (row === undefined || column === undefined) {
      console.warn(`Field ${field.name} has incomplete layout property: row=${row}, column=${column}`);
      return;
    }

    if (!layout[row]) {
      layout[row] = {};
    }

    layout[row][column] = {
      ...field,
      span
    };
  });

  return layout;
};

// Helper function to get maximum columns in a step
export const getMaxColumns = (fields) => {
  let maxColumns = 0;

  fields.forEach(field => {
    if (!field.layout) {
      console.warn(`Field ${field.name} has no layout property`);
      return;
    }

    const { column, span = 1 } = field.layout;

    if (column === undefined) {
      console.warn(`Field ${field.name} has incomplete layout property: column=${column}`);
      return;
    }

    const endColumn = column + span - 1;
    maxColumns = Math.max(maxColumns, endColumn);
  });

  // Default to at least 1 column
  return Math.max(maxColumns, 1);
};
